/* eslint-disable quote-props */
/* eslint-disable import/prefer-default-export */
export const messages = {
  México: {
    modalFree: 'GRATIS',
    modalTitle: '¡Los alineadores Moons son una opción ideal para ti!',
    modalDescription: 'Agenda tu cita con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    modalFreeDescription: 'Agenda tu cita gratis con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    modalPrice: '$99 MXN',
    modalTextBefore: 'Antes: ',
    modalPriceBefore: '$990 MXN',
    modalDisclaimer: 'Reembolso del 100% en caso de que decidas no continuar. Solicítalo en tu cita.'
  },
  Colombia: {
    modalFree: 'GRATIS',
    modalTitle: '¡Los alineadores Moons son una opción ideal para ti!',
    modalDescription: 'Agenda tu cita con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    modalFreeDescription: 'Agenda tu cita gratis con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    modalPrice: '$25.000 COP',
    modalTextBefore: 'Antes: ',
    modalPriceBefore: '$100.000 COP',
    modalDisclaimer: 'Reembolso del 100% en caso de que decidas no continuar. Solicítalo en tu cita.'
  },
  Chile: {
    modalFree: 'GRATIS',
    modalTitle: '¡Los alineadores Moons son una opción ideal para ti!',
    modalDescription: 'Agenda tu cita con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    modalFreeDescription: 'Agenda tu cita gratis con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    modalPrice: '$5.900 CLP',
    modalTextBefore: 'Antes: ',
    modalPriceBefore: '$39.900 CLP',
    modalDisclaimer: 'Reembolso del 100% en caso de que decidas no continuar. Solicítalo en tu cita.'
  },
  Peru: {
    modalFree: 'GRATIS',
    modalTitle: '¡Los alineadores Moons son una opción ideal para ti!',
    modalDescription: 'Agenda tu cita con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    modalFreeDescription: 'Agenda tu cita gratis con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    modalPrice: 'S/19',
    modalTextBefore: 'Antes: ',
    modalPriceBefore: 'S/79',
    modalDisclaimer: 'Reembolso del 100% en caso de que decidas no continuar. Solicítalo en tu cita.'
  }
}

export const informativeModalMessages = {
  Peru: {
    modalTitle: '¡Los Moons son una opción ideal para ti!',
    modalSubTitle: 'Alinea tus dientes sin brackets desde S/ 196 por 12 meses.',
    modalDescriptionText1: 'Agenda tu cita de valoración por',
    modalPrice: ' S/39* ',
    modalDescriptionText2: 'con uno de nuestros ortodoncistas para diseñar tu nueva sonrisa.',
    AppointmentIncludeTitle: 'Cita incluye:',
    AppointmentIncludeStep1: 'Revisión completa',
    AppointmentIncludeStep2: 'Información de tratamiento',
    AppointmentIncludeStep3: 'Simulación 3D de tu sonrisa',
  }
}

export const variantsBySourceModalPrice = {
  México: {
    'default': messages.México.modalPrice,
  },
  Colombia: {
    'default': messages.Colombia.modalPrice,
  },
  Chile: {
    'cl_facebook5900': messages.Chile.modalPrice,
    'cl_facebook7000': '$7.000 CLP',
    'cl_google7000': '$7.000 CLP',
    'cl_google10900': '$10.900 CLP',
    'default': messages.Chile.modalPrice,
  },
  Peru: {
    'default': messages.Peru.modalPrice,
  },

}